import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { useGenereicMutation } from "@/hooks/useGenericMutation"

export function useTrackClickAdMutation() {
  return useGenereicMutation<{ id: number }>({
    createEndpoint: (data) => ENDPOINTS.advertisements.trackClick(data.id),
    method: HTTP_METHODS.POST,
    invalidationKeys: [],
    silent: true,
  })
}

export function useTrackCloseAdMutation() {
  return useGenereicMutation<{ id: number }>({
    createEndpoint: (data) => ENDPOINTS.advertisements.closeModal(data.id),
    method: HTTP_METHODS.POST,
    invalidationKeys: [],
    silent: true,
  })
}
